export default __webpack_public_path__ + "static/knjiga-6b5d217f11fd01d1096063dda386449a.png";